import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { Title } from '@angular/platform-browser';
import { ContactModel } from '../../models/contactModels';
import { AuthService } from '../../services/auth.service';
import { ContactService } from '../../services/contact.service';
import { SnackbarService } from '../../services/snackbar.service';
import { MyConfigService } from '../../services/my-config.service';
import { EventQueueService, AppEventType } from '../../services/eventqueue.service';
import { SelfServiceService } from '../../services/self-service.service';
import { HandleBookingService } from '../../parkifly-bookings/services/handle-booking.service';

declare var $: any;

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LoginDialogComponent } from '../../components/login-dialog/login-dialog.component';

@Component({
  selector: 'app-home',
  templateUrl: './start.component.html',
  styleUrls: ['./start.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
  providers: [
    { provide: MAT_DIALOG_DATA, useValue: {} },
    { provide: MatDialogRef, useValue: { close: () => { } } },
    HandleBookingService
  ]
})
export class StartComponent implements OnInit {
  public contactModel: ContactModel = new ContactModel();
  public messageSent: boolean;
  public messageIsBeeingSent = false;
  public showFlygets = false;
  public showParkifly = false;
  public selectedSite: string = 'flygets';
  public parkingOperators: any = [];
  public locale: string = 'sv';
  public handleBookingGroup: any;

  constructor(
    public authService: AuthService,
    public contactService: ContactService,
    public dialog: MatDialog,
    public snackbar: SnackbarService,
    private router: Router,
    public translate: TranslocoService,
    public title: Title,
    public myConfigService: MyConfigService,
    public eventQueue: EventQueueService,
    private selfServiceService: SelfServiceService,
    private translocoService: TranslocoService,
    private handleBookingService: HandleBookingService
  ) {
    this.translocoService.langChanges$.subscribe((lang) => {
      this.locale = lang;
    });

  }

  ngOnInit(): void {
    localStorage.removeItem('quality-public');
    localStorage.removeItem('aiden-public');
    this.checkCurrentRoute();
    // this.checkConfig();

    this.selfServiceService.getParkingOperators('SWE').then((result) => {
      this.parkingOperators = result?.stations || [];
    });

    this.handleBookingService.initForm(this.selectedSite);
    this.handleBookingGroup = this.handleBookingService.getForm().get('handleBookingGroup');

    this.eventQueue.on(AppEventType.MyConfigLoaded).subscribe(event => {
      this.checkConfig();
    });
  }

  checkConfig() {
    const config = this.myConfigService.getMyConfig();
    if (config && config.showAdmin) {
      this.router.navigate(['/admin/admin-start']);
    }
  }

  checkCurrentRoute() {
    if (
      // window.location.hostname === 'localhost' ||
      // window.location.hostname === 'shuttlebuss-web-test.wittysand-9ea05a62.westeurope.azurecontainerapps.io' ||
      window.location.hostname === 'flygets.se' ||
      window.location.hostname === 'www.flygets.se' ||
      window.location.hostname === 'fyrkantig.se' ||
      window.location.hostname === 'www.fyrkantig.se'
    ) {
      this.showFlygets = true;
      this.title.setTitle('Flygets Långtidsparkering');
    }
    else {
      this.showParkifly = true;
      this.title.setTitle('Parkifly');
    }
  }

  continueBooking(station) {
    if (station.name?.['en'].toLowerCase() === 'arlanda airport') {
      this.router.navigate(['/parkifly/flygets']);
    } else if (station.name?.['en'].toLowerCase() === 'stockholm skavsta airport') {
      this.router.navigate(['/parkifly/skavsta']);
    }
  }

  goToDriveIn() {
    this.router.navigate(['/drivein']);
  }

  goToArlandaLandingPage() {
    this.router.navigate(['/parkifly/aiden-landing-page'], { queryParams: { public: 'true' } });
  }

  manageBookingDialogRef: any;

  goToHandleBookingForm() {
    let email = this.handleBookingService.getForm().get('handleBookingGroup').controls['email'].value;
    let booking_number = this.handleBookingService.getForm().get('handleBookingGroup').controls['bookingNumber'].value;
    if (email && booking_number) {
      this.handleBookingService.getBookingDetails(email, booking_number).subscribe({
        next: ((bookingDetails) => {
          if (bookingDetails.orderStatus != "Cancelled") {
            this.dialog.closeAll();
            this.router.navigate(['parkifly/booking-overview', { email, booking_number }]);
          } else {
            this.snackbar.openSnackBar("Bokningen är inte giltig längre", 'Stäng');
          }
        }),
        error: () => {
          this.snackbar.openSnackBar("Ingen bokning hittades, la du bokningen nyss och betalade med kort kan det ta några minuter", 'Stäng');
        }
      });
    }
  }

  openManageBookingModal(templateRef: any) {
    this.manageBookingDialogRef = this.dialog.open(templateRef, {
      width: '90%',
      maxWidth: '440px',
      panelClass: 'manage-booking-dialog-panel'
    });
  }

  closeManageBookingModal() {
    if (this.manageBookingDialogRef) {
      this.manageBookingDialogRef.close();
    } else {
      this.dialog.closeAll();
    }
  }

  openLoginDialogFromModal() {
    this.closeManageBookingModal();
    this.openLoginDialog();
  }

  openLoginDialog() {
    if (this.authService.loggedIn()) {
      this.router.navigate(['parkifly/my-orders/' + this.selectedSite]);
    } else {
      this.dialog.open(LoginDialogComponent, {
        width: '400px',
        data: { currentRoute: 'parkifly/my-orders/' + this.selectedSite }
      });
    }
  }

}
